import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'

import ui from "./ui";
import auth from "./auth";

//Опросы
import pollsList from "./pollsList";
import pollInfo from "./pollInfo";
import editPoll from "./editPoll";

//Клиенты и консультанты
import clientsList from "./clientsList";
import consultantsList from "./consultantsList";
import consultantClientsList from "./consultantClientsList";
import consultantInfo from "./consultantInfo";

//Шаблоны визиток
import templatesList from "./templatesList";
import templateInfo from "./templateInfo";
import editTemplate from "./editTemplate";

//Аналитика
import analytics from "./analytics";

//Сообщения
import messagesList from "./messagesList";
import messageInfo from "./messageInfo";
import editMessage from "./editMessage";

//Вопросы
import questionsList from "./questionsList";
import questionInfo from "./questionInfo";
import editQuestion from "./editQuestion";

import blockedPhones from './blockedPhones';

//Локализации
import localizationsList from "./localizationsList";

export default history => combineReducers({
  router: connectRouter(history),
  auth,
  ui,
  questionsList,
  questionInfo,
  editQuestion,
  messagesList,
  messageInfo,
  editMessage,
  analytics,
  pollsList,
  pollInfo,
  editPoll,
  clientsList,
  consultantsList,
  consultantClientsList,
  consultantInfo,
  templatesList,
  templateInfo,
  editTemplate,
  blockedPhones,
  localizationsList,
});
